import React from "react";
import PortfolioHero from "../components/PortfolioHero";

const Home: React.FC = () => {
  return <PortfolioHero />;
};

export default Home;
